import type { FunctionComponent } from 'react'
import type { KeyMap } from './TypeUtils'
import type { BrandKey } from '@jotta/config/brand'
import { brandKeys } from '@jotta/config/brand'

export * from '@jotta/config/brand'

export interface BreakpointWidth {
  min: number
  mid: number
  max: number
}
export type BrandThemeIcon = FunctionComponent<{
  width?: string | number
  height?: string | number
}>

export function isBrandKey(value: any): value is BrandKey {
  return typeof value === 'string' && brandKeys.includes(value as BrandKey)
}
export type BrandMap<T> = KeyMap<BrandKey, T>
export type BreakpointList<T> = [T, T, T]
export type ResponsiveValue<T> = T[]

export interface BrandConfig {
  brand: BrandKey
  disableCookieConsent?: boolean
  /** Path to theme file */
  themedir: string
  /** Path to app icon SVG file, used to generate app icons  */
  appIconSvg: string
  /** Path to fsvicon SVG file, used to generate favicon  */
  favIconSvg: string
  /** Directory under /webapp_static to put brand assets and generated icons */
  staticDir: string
  height: number
  sidebar: {
    closedWidth: ResponsiveValue<number | string>
    openWidth: ResponsiveValue<number | string>
  }
  header: {
    height: number
    showHamburger: boolean
    showSignupButtons: boolean
  }
  topToolBar: {
    height: number
  }
  bottomToolBar: {
    height: number
  }
  photos: {
    timeline: {
      headerRowAspect: ResponsiveValue<number>
      imageRowAspect: ResponsiveValue<number>
      scrubberWidth: ResponsiveValue<number>
      mobileTimelineBreakpoint: number
    }
  }
  learnMoreLinkWaitlist?: number
  learnMoreLinkSearch?: number
  files: {
    folderRowHeight: number
    folderColumnWidth: number
    folderThumbAspect: number
    publicFolderRowHeight: number
  }
  showLanguageSelector: boolean
}
